<span
    class="case-history-container"
    (click)="toggleDropdown()"
>
    <mat-icon>history</mat-icon>
    <div
        class="case-history-dropdown"
        *ngIf="isCaseHistoryDropdownOpen"
        [@fadeIn]
        (click)="$event.stopPropagation()"
    >
        <div class="dropdown-header-title">My Case History</div>
        <mat-form-field
            id="filterCaseHistoryFormField"
            class="filter-case-history w-100"
            floatLabel="never"
            appearance="fill"
        >
            <input
                matInput
                placeholder="Search"
                name="filterValue"
                (keyup)="updateFilteredCaseHistory($event.target.value)"
                [(ngModel)]="filterValue"
                style="font-size: 14px"
            >
            <mat-icon
                class="case-history-search-icon mat-icon-small"
                aria-hidden="false"
                aria-label="Case history search icon"
                matTextSuffix
            >
                search
            </mat-icon>
        </mat-form-field>
        @for (caseHistory of filteredCaseHistory; track caseHistory.id)
        {
            <mat-card class="case-history-card" (click)="viewCaseDetails(caseHistory)">
                <div class="left">
                    <div class="case-history-header">
                        <span class="case-history-caseNumberDisplay">{{ caseHistory.caseNumberDisplay }}</span>
                    </div>
                    <div class="case-history-accessed-date">
                        <span>Accessed: {{ caseHistory.lastModifiedDate | date: 'MMMM d, y, h:mm a' }}</span>
                    </div>
                </div>
                <div class="right-arrow">
                    <mat-icon color="primary">chevron_right</mat-icon>
                </div>
            </mat-card>
        }
    </div>
</span>